import { RootState } from '@box/redux/types';

export const popupList = (state: RootState) => state.app.infoPopup.popupList;
